import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import ChargeStationLeafletMapView from '../../components/ChargeStationLeafletMapView';

ChargeStationMapScreen.propTypes = {};

function ChargeStationMapScreen(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <ChargeStationLeafletMapView />
      </div>
    </KT01BaseLayout>
  );
}

export default ChargeStationMapScreen;
